export const figure13b = {
    chart: {
        type: 'line',
        backgroundColor: 'rgba(255, 255, 255, 0.0)',
        height: 230,
        plotBackgroundColor: null,
        plotBorderWidth: null,
      },
      credits: {
        enabled: false
    },
      title: {
        text: 'Ouganda'
      },
      subtitle: {
        text: null
    },
      xAxis: {
        categories: ['2010','2011','2012', '2014', '2016',]
      },
      labels: {
        	
        style: {
          fontWeight: 'normal',
          color: '#999999',
          fontSize: '12px'
        },
      },
      yAxis: {
        min: 0,
        max: 8,
        tickInterval: 2,
        title: {
            text: null,
        },
      },
      plotOptions: {
        line: {
          dataLabels: {
            enabled: false
          },
          enableMouseTracking: true
        }
    },
    legend: {
        enabled: false,
    },
      colors: ['#5b9bd5', '#ed7d32','#cbcccb', '#ffc100'],
      series: [{
        name: 'Petites exploitations',
        data: [4.3, 3.6, 4.1, 3.6, 3.6,]
      }, {
        name: 'Autres exploitations',
        data: [6.7, 5.4, 6.1, 4.7, 4.6,]
      },{
        name: 'Petites exploitations dirigées par une femme',
        data: [3.9, 3.5, 3.5, 4.2, 3.3,]
      },{
        name: 'Petites exploitations dirigées par un homme',
        data: [4.5, 3.6, 4.4, 3.3, 3.7,]
      }]
    }

    